export const loginReducers = (state = false, action) => {
  if (action.type === "LOGIN_ACTIONS") return action.status;
  return state;
};
